export default class SingletonStore {
  constructor() {
    this.listeners = [];
  }

  listen = (listener) => {
    this.listeners.push(listener);
  };

  call = (option) => {
    this.listeners.forEach((listener) => listener(option));
  };
}
